import React from "react";

interface Props {
  lableText: string;
  className: string;
  onChangeFunction: any;
  value: boolean;
  id ?:number;
  marginTop?:string
}

const CheckBoxInput: React.FC<Props> = ({
  lableText,
  className,
  onChangeFunction,
  value,
  id,
  marginTop
}) => {
  return (
    <div style={{marginTop:marginTop}} className={className}>
      <div onClick={() => onChangeFunction(id !== undefined ? id : !value)}></div>
      <p onClick={() => onChangeFunction(id !== undefined ? id : !value)}>{lableText}</p>
    </div>
  );
};

export default CheckBoxInput;
